import React, { VFC } from 'react';
import { Theme, useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import clsx from 'clsx';
import Character from '~/src/feature/toyono/components/Character';
import Title from '~/src/feature/toyono/components/Title';
import Typography from '@material-ui/core/Typography';
import OsakaAreaImage from '../../../../images/features/toyono/osaka_area.png';

const useStyles = makeStyles((theme) => ({
  descriptionText: {
    letterSpacing: '1px',
    lineHeight: 1.8,
  },
  separation: {
    marginBottom: theme.spacing(3),
  },
}));

const Container = styled.div<{ theme: Theme }>`
  margin: ${({ theme }) => theme.spacing(0, 0, 4)};
  padding: ${({ theme }) => theme.spacing(0, 0, 4)};
  width: 100%;
  text-align: center;
  border-bottom: #00722e 1px solid;
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 1200px;
    margin: ${({ theme }) => theme.spacing(0, 'auto', 10)};
    border-bottom: none;
  }
`;

const Description = styled.div`
  margin: ${({ theme }) => theme.spacing(0, 3, 5)};
  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row-reverse;
    display: flex;
    margin-bottom: ${({ theme }) => theme.spacing(5)}px;
  }
`;

const DescriptionText = styled.div<{ theme: Theme }>`
  text-align: left;
  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: ${({ theme }) => theme.spacing(15, 0, 0)};
    width: 70%;
  }
`;

const Img = styled.img<{ theme: Theme }>`
  width: 60%;
  height: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(3)}px;
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 25%;
    margin: 5% 7% 0 7%;
  }
`;

interface Props {}

const About: VFC<Props> = () => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Container theme={theme}>
      <Title text="WHAT’S TOYONO-CHO?">豊能町ってどんなところ？</Title>
      <Description theme={theme}>
        <Img src={OsakaAreaImage} theme={theme} alt="大阪" />
        <DescriptionText theme={theme}>
          <Typography className={classes.descriptionText}>
            豊能町は、大阪の北部、北大阪地域に属し、標高600mを超える北摂連山に囲まれた、町域の7割が山林に
            占められた自然豊かなまちです。京都・兵庫とも面しており、3都道府県の生活圏が交差しています。
          </Typography>
          <Typography
            className={clsx(classes.descriptionText, classes.separation)}
          >
            また、北摂山系の妙見山や初谷川の渓谷・棚田など自然豊かな四季を
            感じられる“いなか”の顔と、閑静な住宅地が同居する“まち”の顔を併せ持っています。
          </Typography>
          <Typography
            className={clsx(classes.descriptionText, classes.separation)}
          >
            しかし一方で、人口減少や少子高齢化の課題を抱えており農作業をする人の減少により耕作放棄地が増えてきているなどのまちの課題を抱えています。
          </Typography>
          <Typography className={classes.descriptionText}>
            今回はそのような課題を解決し、自然を活かした人の暮らしの豊かさを再発見するためのおてつたびをご用意しました。
          </Typography>
        </DescriptionText>
      </Description>
      <Character />
    </Container>
  );
};

export default About;
